<div *ngIf="form" [formGroup]="form" class="container">
  <div class="row">
    <div class="col-6">
      <div class="form-control">
        <mat-form-field appearance="outline">
          <mat-label>Customer Email Address</mat-label>
          <input matInput [formControl]="form.controls.customerEmail">
          <mat-error *ngIf="form.controls.customerEmail.hasError('required')">
            {{errorMessages.customerEmail.required}}
          </mat-error>
          <mat-error *ngIf="form.controls.customerEmail.hasError('pattern')">
            {{errorMessages.customerEmail.pattern}}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-control form-control-no-margin">
        <mat-form-field appearance="outline">
          <mat-label>Customer Account Number</mat-label>
          <input matInput [formControl]="form.controls.customerAccountNumber">
          <mat-error *ngIf="form.controls.customerAccountNumber.hasError('required')">
            {{errorMessages.customerAccountNumber.required}}
          </mat-error>
          <mat-error *ngIf="form.controls.customerAccountNumber.hasError('pattern')">
            {{errorMessages.customerAccountNumber.pattern}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
